import * as Url from "../Url";
import * as Services from "../handler";

export async function getT(d: string, appName: string = 'SnaptoonWeb'): Promise<any> {
  let res = await Services.GET(
    `${Url.GET_USER_T}/${d}?app_name=${encodeURIComponent(appName)}`,
    { skipAuthRetry: true }
  );
  return res;
}
